import {Component} from "@angular/core";
import {NavbarComponent} from "../../../components/navbar/navbar.component";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'btw-academy-header',
  standalone: true,
  imports: [
    NavbarComponent,
    TranslateModule
  ],
  styleUrl: '../btw-academy.scss',
  templateUrl: 'btw-academy-header.html'
})
export class BtwAcademyHeader {

}
